import { projectEmployeeSortConstants } from "../constant/totalRecord.constants";

export const initialState = {
    dataProjectEmployeeSort: [],
    errorCode: '',
    successCode: '',
    isLoading: false
};
const projectEmployeeSortReducer = (state = initialState, action) => {
    switch (action.type) {
        case projectEmployeeSortConstants.GET_SUCCESS:
            return {
                ...state,
                dataProjectEmployeeSort: action.projectEmployeeSortList,
            };
        default:
            return state;
    }
};

export default projectEmployeeSortReducer;
